import { Grid, TextField as MuiTextField } from "@mui/material";
import { styled, css } from "@mui/material/styles";

const commonStyles = css({
  margin: "10px 0 0",
  width: "45%",
});

export const RootContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
});

export const TextField = styled(MuiTextField)({
  ...commonStyles,
});

export const Dropdown = styled(Grid)({
  ...commonStyles,
});
